/** @jsx onetext.jsx.element */

import type { OneText } from '../../../global';

// eslint-disable-next-line no-restricted-syntax
import { BrandBackgroundDefault as BrandBackground, BrandLogoDefault as BrandLogo } from '../components';
// eslint-disable-next-line no-restricted-syntax
import { defaultBrandConfig, SUPPRESSED_ROUTES } from '../config';
// eslint-disable-next-line no-restricted-syntax
import { ClothingGraphic as HeroGraphic } from '../images';

import type { GetPopupAPIResponse } from '@onetext/api';
import { POPUP_LAYOUT } from '@onetext/api';

declare let onetext : OneText;

const { clsx } = onetext.jsx;

const {
    Popup,
    Page,
    PhoneField,
    Button,
    Row,
    Columns,
    Column,
    Terms,
    Teaser,
    PopupContainer
} = onetext.component.consent.popup;

type SMSSignupPopupProps = {
    popup : GetPopupAPIResponse,
};

export const SMSSignupPopup = ({
    popup
} : SMSSignupPopupProps) : JSX.Element | null => {
    return (
        <PopupContainer
            popup={ { ...popup, config: defaultBrandConfig } }
            suppressedRoutes={ SUPPRESSED_ROUTES }>
            <Popup
                layout={ POPUP_LAYOUT.FULLSCREEN }
                background={ <BrandBackground /> }>
                <Page>
                    <Row>
                        <Columns className={ 'gap-24' }>
                            <Column>
                                <div className={ 'mb-10' }>
                                    <BrandLogo />
                                </div>
                                <p className={
                                    clsx(
                                        'text-[40px]',
                                        'font-semibold',
                                        'uppercase',
                                        'tracking-wider',
                                        'text-center',
                                        'md:whitespace-nowrap'
                                    )
                                }>
                                    { 'Finish signing up' }
                                </p>
                                <p className={
                                    clsx(
                                        'text-md',
                                        'font-light',
                                        'leading-relaxed',
                                        'text-center',
                                        'mt-3',
                                        'mb-6',
                                        'w-[280px]',
                                        'md:whitespace-nowrap'
                                    )
                                }>
                                    { 'with text to activate your 15% off discount' }
                                </p>
                                <Terms
                                    brandName={ 'Caden Lane' }
                                    termsUrl={ 'https://cadenlane.com/Pages/terms-of-service' }
                                    privacyUrl={ 'https://cadenlane.com/Pages/privacy-policy' }
                                />
                                <div className={
                                    clsx(
                                        'w-[264px]',
                                        'flex',
                                        'flex-col',
                                        'items-center',
                                        'gap-2.5',
                                        'mt-8'
                                    )
                                }>
                                    <PhoneField autofocus={ true } />
                                    <Button>
                                        { 'Activate 15% Off' }
                                    </Button>
                                </div>
                            </Column>
                            <Column className={ clsx('w-96', 'hidden', 'md:flex') }>
                                <img src={ HeroGraphic } />
                            </Column>
                        </Columns>
                    </Row>
                </Page>

                <Page>
                    <Row>
                        <Columns className={ 'gap-24' }>
                            <Column>
                                <div className={ 'mb-10' }>
                                    <BrandLogo />
                                </div>
                                <p className={
                                    clsx(
                                        'text-7xl',
                                        'uppercase',
                                        'tracking-wider',
                                        'text-center',
                                        'font-semibold',
                                        'md:whitespace-nowrap'
                                    )
                                }>
                                    { 'You\'re in!' }
                                </p>
                                <p className={
                                    clsx(
                                        'text-2xl',
                                        'font-light',
                                        'tracking-wider',
                                        'text-center',
                                        'w-[280px]',
                                        'mt-3',
                                        'mb-10'
                                    )
                                }>
                                    { 'Check your texts for your 15% off discount.' }
                                </p>
                                <div className={
                                    clsx(
                                        'w-[264px]',
                                        'flex',
                                        'flex-col',
                                        'items-center',
                                        'gap-2.5'
                                    )
                                }>
                                    <Button>
                                        { 'Back to site' }
                                    </Button>
                                </div>
                            </Column>
                            <Column className={ 'w-96 hidden md:flex' }>
                                <img src={ HeroGraphic } />
                            </Column>
                        </Columns>
                    </Row>
                </Page>
            </Popup>
            <Teaser customText={ 'Get 15% off' } />
        </PopupContainer>
    );
};
